import { inject } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { SchedulerModel } from '../../model/scheduler-model';
import { SerieSettingEntity } from '../../apis/serie/serie-setting-entity';
import { TeamSettingEntity } from '../../apis/team/team-setting-entity';
import { ScheduleRowEntity } from '../../apis/schedule/schedule-row-entity';
import { CustomIntervalEntity } from '../../apis/custom-interval/custom-interval-entity';
import { VenueEntity } from '../../apis/venue/venue-entity';
import { SchedulerModelService } from '../../services/scheduler-model-service';
import { ProjectModelService } from '../../services/project-model-service';

@inject(IRouter, SchedulerModelService, ProjectModelService)
export class CustomizeSchedule {

    private _schedulerModel: SchedulerModel = null;
    private _router: IRouter = null;
    private _schedulerModelService: SchedulerModelService;
    private _projectModelService: ProjectModelService;

    constructor(router: IRouter, schedulerModelService: SchedulerModelService, projectModelService: ProjectModelService) {
        this._router = router;
        this._schedulerModelService = schedulerModelService;
        this._projectModelService = projectModelService;
    }

    public canLoad(): boolean {
        if (!this._schedulerModelService.isLoaded) {
            setTimeout(() => void this._router.load('create'), 0);
            return false;
        }
        return true;
    }

    public loading(): void {
        this._schedulerModel = this._schedulerModelService.model;
    }

    public get games(): ScheduleRowEntity[] {
        return this._schedulerModel.games;
    }
    public get customIntervals(): CustomIntervalEntity[] {
        return this._schedulerModel.customIntervals;
    }
    public get serie(): SerieSettingEntity {
        return this._schedulerModel.serie;
    }
    public set serie(value) {
        this._schedulerModel.serie = value;
    }
    public get teamSettings(): TeamSettingEntity[] {
        return this._schedulerModel.teamSettings;
    }
    public get venues(): VenueEntity[] {
        return this._projectModelService.getVenuesForEvent();
    }
    public get showCancel(): boolean {
        return true;
    }
    public previous(): void {
        void this._router.load('create/edit-schedule');
    }

    public next(): void {
        void this._router.load('create/review-schedule');
    }

    public finish(): void {
        this._projectModelService.finalizeSchedule(this._schedulerModel);
        void this._router.load(`create/event-summary/${this._schedulerModel.eventId}`);
    }

    public cancel(): void {
        void this._router.load(`create/event-summary/${this._schedulerModel.eventId}`);
    }
}
